import { fetchAuth } from "."

const PROJECTS_URL = `${process.env.VUE_APP_API}/projects`

/** @type {import("vuex").Module} */
export const projectStore = {
  namespaced: true,

  state: {
    projectFilter: null,
    projectList: [],
    projectCount: null,

    project: null,
    projectBom: null,
    projectValidation: null,
    loadingProjectValidation: false,
  },

  getters: {
    status: (state) => state.project && state.project.status,
    disabled: (_state, getters) => getters.status != 'created',
    projectUrl: (_state, _getters, rootState) => {
      if (rootState.projects.project == null) return
      return `${PROJECTS_URL}/${rootState.projects.project.number}`
    }
  },

  mutations: {
    setProjectFilter: (state, filter) => state.projectFilter = filter,
    setProjectList: (state, { projects, totalCount }) => {
      state.projectList = projects
      state.projectCount = totalCount
    },
    setProject: (state, project) => state.project = project,
    setProjectBom: (state, bom) => state.projectBom = bom,
    setProjectValidation: (state, validation) => state.projectValidation = validation,
    setLoadingProjectValidation: (state, loading) => state.loadingProjectValidation = loading,
  },

  actions: {
    async loadProjectList({ state, commit }) {
      const query = new URLSearchParams({
        query: state.projectFilter.query,
        sortby: state.projectFilter.sortBy,
        limit: state.projectFilter.limit,
        offset: state.projectFilter.offset,
      })
      const res = await fetchAuth(`${PROJECTS_URL}?${query}`)
      const json = await res.json()
      commit("setProjectList", {
        projects: json.projects,
        totalCount: json.count
      })
    },
    async loadProject({ state, commit }, projectNumber) {
      const res = await fetchAuth(`${PROJECTS_URL}/${projectNumber || state.project.number}`)
      commit("setProject", await res.json())
    },
    async createProject({ state, commit }, projectInfo) {
      const res = await fetchAuth(`${PROJECTS_URL}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(projectInfo)
      })
      commit("setProject", await res.json())
      return state.project
    },
    async changeProjectInfo({ state, commit }, projectInfo) {
      commit("setProject", {
        ...state.project,
        name: projectInfo.name,
        description: projectInfo.description
      })
      await fetchAuth(`${PROJECTS_URL}/${state.project.number}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(projectInfo)
      })
    },
    async deleteProject(_, projectNumber) {
      await fetchAuth(`${PROJECTS_URL}/${projectNumber}`, {
        method: "DELETE"
      })
    },
    async saveProject({ state }) {
      await fetchAuth(`${PROJECTS_URL}/${state.project.number}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(state.project)
      })
    },
    async orderProject({ state, dispatch }) {
      await fetchAuth(`${PROJECTS_URL}/${state.project.number}/order`, {
        method: "POST"
      })
      await dispatch("loadProject")
    },
    async generatePDF({ state }) {
      const res = await fetchAuth(`${PROJECTS_URL}/${state.project.number}/pdf`)
      return URL.createObjectURL(await res.blob())
    },
    async requestSupport({ state }, { message }) {
      await fetchAuth(`${PROJECTS_URL}/${state.project.number}/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(message),
      })
    },
    async requestProject({ state, dispatch }, { message }) {
      await fetchAuth(`${PROJECTS_URL}/${state.project.number}/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(message),
      })
      await dispatch("loadProject")
    },
    async generateBom({ state, commit }) {
      commit("setProjectBom", null)
      const res = await fetchAuth(`${PROJECTS_URL}/${state.project.number}/bom`)
      commit("setProjectBom", await res.json())
    },
    async validate({ state, commit }) {
      commit("setLoadingProjectValidation", true)
      commit("setProjectValidation", null)
      try {
        const response = await fetchAuth(`${PROJECTS_URL}/${state.project.number}/validate`, {
          method: "POST"
        })
        const result = await response.json()
        commit("setProjectValidation", result)
        return result
      } finally {
        commit("setLoadingProjectValidation", false)
      }
    }
  }
}
